angular.module('workflow.app')

.factory( 'ProjectStarredDocuments', ( Collection, Api, ProjectStarredDocument ) ->

  class ProjectStarredDocuments extends Collection

    getRecordClass: ->
      ProjectStarredDocument

    getApiClass: ->
      Api.ProjectStarredDocument

)
